import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Response } from '../../../shared/models/response.model';
import { IndicateurPerformance } from './models/indicateur-performance';
import { IndicateurCreateRequest } from './requests/create-request';
import { IndicateurUpdateRequest } from './requests/update-request';

@Injectable({
  providedIn: 'root',
})
export class IndicateurPerformanceService {
  #http = inject(HttpClient);

  readonly BASE_URL = '/indicateurs-performance';

  trouverParId(idIndice: string): Observable<IndicateurPerformance> {
    return this.#http.get<IndicateurPerformance>(this.BASE_URL + '/' + idIndice);
  }

  trouverTous = (idReferentiel: string) =>
    this.#http.get<Response<IndicateurPerformance>>(this.BASE_URL, { params: { idReferentiel } });

  créer = (data: IndicateurCreateRequest) => this.#http.post<IndicateurPerformance[]>(this.BASE_URL, data);

  modifier(data: IndicateurUpdateRequest) {
    return this.#http.put<string>(this.BASE_URL, data);
  }

  supprimer(idIndice: string) {
    return this.#http.delete<void>(this.BASE_URL + '/' + idIndice);
  }
}
